import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import { VERSION } from '@/constants';
import LoginService from '@/account/login.service';
import AccountService from '@/account/account.service';
import TranslationService from '@/locale/translation.service';
import AdminService from '@/admin/admin.service';
import { Authority } from '@/shared/security/authority';

import PortalUserService from '@/entities/portal-user/portal-user.service';

//b2b
import { IPortalUser } from '@/shared/model/portal-user.model';
import RiServiceService from '@/entities/ri-service/ri-service.service';
import RequestsPreviewService from '@/entities/requests-preview/requests-preview.service';
import CollaborationService from '@/entities/collaboration/collaboration.service';

@Component
export default class JhiNavbar extends Vue {
  @Inject('loginService')
  private loginService: () => LoginService;
  @Inject('riServiceService') private riServiceService: () => RiServiceService;
  @Inject('translationService') private translationService: () => TranslationService;
  @Inject('adminService') private adminService: () => AdminService;

  @Inject('accountService') private accountService: () => AccountService;
  @Inject('portalUserService') private portalUserService: () => PortalUserService;
  @Inject('requestsPreviewService') private requestsPreviewService: () => RequestsPreviewService;
  @Inject('collaborationService') private collaborationService: () => CollaborationService;

  public version = VERSION ? 'v' + VERSION : '';
  private currentLanguage = this.$store.getters.currentLanguage;
  private languages: any = this.$store.getters.languages;
  private hasAnyAuthorityValue = false;
  private hasAnyRoleValue = false;
  public isAdminValue = false;
  public isCompanyAdminValue = false;
  public isCMSSuperAdminValue = false;
  public isCMSAdminValue = false;
  public isSuperAdminValue = false;
  public isNioAdminValue = false;
  public isCompanyOrgAdminValue = false;
  public isNioOrgAdminValue = false;
  public isNioUserValue = false;
  public isCompanyUserValue = false;
  public isCompanySuperAdminValue = false;
  public isNioSuperAdminValue = false;
  public newRequestsCount = 0;
  public newCollaborationsCount = 0;

  private isPrviNavVisible = true;
  public portalUser: IPortalUser = null;
  public companyId: number;
  public companyLink = '';

  public services: any[] = [];

  public search = {
    searchTerms: '',
    currentLanguage: '',
  };

  async created() {
    this.translationService().refreshTranslation(this.currentLanguage);

    // Wait for all role checks to complete before rendering
    await Promise.all([
      this.setIsAdmin(),
      this.setIsCompanyAdmin(),
      this.setIsCMSSuperAdmin(),
      this.setIsCMSAdmin(),
      this.setIsSuperAdmin(),
      this.setIsNioAdmin(),
      this.setIsCompanyOrgAdmin(),
      this.setIsNioOrgAdmin(),
      this.setIsNioUser(),
      this.setIsCompanyUser(),
      this.setIsCompanySuperAdmin(),
      this.setIsNioSuperAdmin(),
    ]);

    await this.portalUserService().getRoles();

    // Fetch new requests and collaborations count after authentication is confirmed
    if (this.authenticated) {
      this.fetchNewRequestsCount();
      this.fetchNewCollaborationsCount();
    }
  }

  // Watch for authentication changes and update roles
  @Watch('authenticated')
  async onAuthenticationChanged(newValue: boolean, oldValue: boolean) {
    if (newValue && newValue !== oldValue) {
      // User just logged in, refresh all role checks
      await Promise.all([
        this.setIsAdmin(),
        this.setIsCompanyAdmin(),
        this.setIsCMSSuperAdmin(),
        this.setIsCMSAdmin(),
        this.setIsSuperAdmin(),
        this.setIsNioAdmin(),
        this.setIsCompanyOrgAdmin(),
        this.setIsNioOrgAdmin(),
        this.setIsNioUser(),
        this.setIsCompanyUser(),
        this.setIsCompanySuperAdmin(),
        this.setIsNioSuperAdmin(),
      ]);

      await this.portalUserService().getRoles();

      // Fetch new requests and collaborations count after login
      this.fetchNewRequestsCount();
      this.fetchNewCollaborationsCount();
    }
  }

  // moj kod

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  }

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  goToServicesSearch() {
    const q = (this.search?.searchTerms || '').trim();
    this.$router.push({ name: 'RiServicePregled', query: { q } });
  }
  private handleScroll() {
    this.isPrviNavVisible = window.scrollY < window.innerHeight * 0.3;
  }

  public subIsActive(input) {
    const paths = Array.isArray(input) ? input : [input];
    return paths.some(path => {
      return this.$route.path.indexOf(path) === 0; // current path starts with this path string
    });
  }

  public changeLanguage(newLanguage: string): void {
    this.translationService().refreshTranslation(newLanguage);
  }

  public isActiveLanguage(key: string): boolean {
    return key === this.$store.getters.currentLanguage;
  }
  /**
  public logout(): void {
    localStorage.removeItem('jhi-authenticationToken');
    sessionStorage.removeItem('jhi-authenticationToken');
    this.$store.commit('logout');
    this.$router.push('/');
  }
**/

  get isHomepage(): boolean {
    return this.$route.path === '/';
  }

  public searchRiService(): void {
    this.search.currentLanguage = this.currentLanguage;
    this.riServiceService()
      .searchAll(this.search)
      .then(
        res => {
          this.services = res.data;
        },
        err => {}
      );
  }
  public async logout(): Promise<void> {
    // Check user authorities to determine logout type
    const isCompanyUser = await this.hasAnyAuthority(Authority.COMPANY_USER);
    const isCompanyAdmin = await this.hasAnyAuthority(Authority.COMPANY_ADMIN);
    const isCompanySuperAdmin = await this.hasAnyAuthority(Authority.COMPANY_SUPER_ADMIN);
    const isSuperAdmin = await this.hasAnyAuthority(Authority.SUPER_ADMIN);
    const isNioAdmin = await this.hasAnyAuthority(Authority.NIO_ADMIN);
    const isNioOrgAdmin = await this.hasAnyAuthority(Authority.NIO_ORG_ADMIN);
    const isCompanyOrgAdmin = await this.hasAnyAuthority(Authority.COMPANY_ORG_ADMIN);

    // Company users and company admins use admin logout
    // Company super admin + company admin combination uses regular logout
    const shouldUseAdminLogout =
      isCompanyUser || (isCompanyAdmin && !isCompanySuperAdmin) || isSuperAdmin || isNioAdmin || isNioOrgAdmin || isCompanyOrgAdmin;

    if (shouldUseAdminLogout) {
      this.adminService()
        .adminLogout()
        .then(() => {
          this.$store.commit('logout');
          this.$router.push('/').catch(() => {
            // Ignore navigation duplicated error
          });
        })
        .catch(error => {
          console.error('Error during admin logout:', error);
          this.performRegularLogout();
        });
    } else {
      this.performRegularLogout();
    }
  }

  private performRegularLogout(): void {
    this.loginService()
      .logout()
      .then(response => {
        this.$store.commit('logout');
        this.$router.push('/').catch(() => {
          // Ignore navigation duplicated error
        });
        const data = response.data;
        let logoutUrl = data.logoutUrl;
        // if Keycloak, uri has protocol/openid-connect/token
        if (logoutUrl.indexOf('/protocol') > -1) {
          logoutUrl = logoutUrl + '?redirect_uri=' + window.location.origin;
        } else {
          // Okta
          logoutUrl = logoutUrl + '?id_token_hint=' + data.idToken + '&post_logout_redirect_uri=' + window.location.origin;
        }
        window.location.href = logoutUrl;
      });
  }

  public openLogin(): void {
    //this.loginService().openLogin((<any>this).$root); old for jwt auth.
    this.loginService().login();
  }

  public get authenticated(): boolean {
    this.getCompanyLink();
    return this.$store.getters.authenticated;
  }

  public async hasAnyAuthority(authorities: any): Promise<boolean> {
    return await this.accountService().hasAnyAuthorityAndCheckAuth(authorities);
  }

  public async setIsAdmin(): Promise<void> {
    this.isAdminValue = (await this.hasAnyAuthority('ROLE_ADMIN')) || (await this.hasAnyAuthority('ROLE_SUPER_ADMIN'));
  }

  public async setIsCompanyAdmin(): Promise<void> {
    this.isCompanyAdminValue = await this.hasAnyAuthority('ROLE_COMPANY_ADMIN');
  }

  public async setIsCMSSuperAdmin(): Promise<void> {
    this.isCMSSuperAdminValue = await this.hasAnyAuthority('ROLE_CMS_SUPER_ADMIN');
  }

  public async setIsCMSAdmin(): Promise<void> {
    this.isCMSAdminValue = await this.hasAnyAuthority('ROLE_CMS_ADMIN');
  }

  public async setIsSuperAdmin(): Promise<void> {
    this.isSuperAdminValue = await this.hasAnyAuthority('ROLE_SUPER_ADMIN');
  }

  public async setIsNioAdmin(): Promise<void> {
    this.isNioAdminValue = await this.hasAnyAuthority('ROLE_NIO_ADMIN');
  }

  public async setIsCompanyOrgAdmin(): Promise<void> {
    this.isCompanyOrgAdminValue = await this.hasAnyAuthority('ROLE_COMPANY_ORGANIZATION_ADMIN');
  }

  public async setIsNioOrgAdmin(): Promise<void> {
    this.isNioOrgAdminValue = await this.hasAnyAuthority('ROLE_NIO_ORGANIZATION_ADMIN');
  }

  public async setIsNioUser(): Promise<void> {
    this.isNioUserValue = await this.hasAnyAuthority('ROLE_NIO_USER');
  }

  public async setIsCompanyUser(): Promise<void> {
    this.isCompanyUserValue = await this.hasAnyAuthority('ROLE_COMPANY_USER');
  }

  public async setIsCompanySuperAdmin(): Promise<void> {
    this.isCompanySuperAdminValue = await this.hasAnyAuthority('ROLE_COMPANY_SUPER_ADMIN');
  }

  public async setIsNioSuperAdmin(): Promise<void> {
    this.isNioSuperAdminValue = await this.hasAnyAuthority('ROLE_NIO_SUPER_ADMIN');
  }

  public hasAnyRole(roles: any): boolean {
    if (this.userRoles) {
      for (let i = 0; i < roles.length; i++) {
        if (this.userRoles.includes(roles[i])) {
          return true;
        }
      }
    }
    return false;
  }

  public checkRoles(rolesFromServer: any, roles: any): boolean {
    for (let i = 0; i < rolesFromServer.length; i++) {
      for (let j = 0; j < roles.length; j++) {
        if (rolesFromServer[i] == roles[j]) {
          return true;
        }
      }
    }
    return false;
  }

  public get userRoles(): any {
    return this.$store.getters.roles;
  }

  get isAdmin(): boolean {
    return this.isAdminValue;
  }

  get isCompanyAdmin(): boolean {
    return this.isCompanyAdminValue;
  }

  get isCMSSuperAdmin(): boolean {
    return this.isCMSSuperAdminValue;
  }

  get isCMSAdmin(): boolean {
    return this.isCMSAdminValue;
  }

  get isSuperAdmin(): boolean {
    return this.isSuperAdminValue;
  }

  get isNioAdmin(): boolean {
    return this.isNioAdminValue;
  }

  get isNioSuperAdmin(): boolean {
    return this.isNioSuperAdminValue;
  }

  get isCompanyOrgAdmin(): boolean {
    return this.isCompanyOrgAdminValue;
  }

  get isNioOrgAdmin(): boolean {
    return this.isNioOrgAdminValue;
  }

  get isNioUser(): boolean {
    return this.isNioUserValue;
  }

  get isCompanyUser(): boolean {
    return this.isCompanyUserValue;
  }

  get isCompanySuperAdmin(): boolean {
    return this.isCompanySuperAdminValue;
  }

  // Helper to check if user has any B2B role
  get hasB2BRole(): boolean {
    return this.isCompanyAdmin || this.isCompanySuperAdmin || this.isCompanyUser || this.isCompanyOrgAdmin || this.isSuperAdmin;
  }

  get hasB2BAdminRole(): boolean {
    return this.isCompanyAdmin || this.isCompanySuperAdmin || this.isCompanyOrgAdmin || this.isSuperAdmin;
  }

  public get swaggerEnabled(): boolean {
    return this.$store.getters.activeProfiles.indexOf('swagger') > -1;
  }

  public get inProduction(): boolean {
    return this.$store.getters.activeProfiles.indexOf('prod') > -1;
  }

  //ivin kod
  public get settingsAccount(): any {
    return this.$store.getters.account;
  }

  public async fetchNewRequestsCount(): Promise<void> {
    try {
      // Fetch all incoming requests (we need to filter on client side)
      const [servicesResponse, infrastructuresResponse] = await Promise.all([
        this.requestsPreviewService().getServiceRequests('incoming', 0, 1000),
        this.requestsPreviewService().getInfrastructureRequests('incoming', 0, 1000),
      ]);

      // Count only requests without a respond (unanswered)
      const serviceRequests = servicesResponse.data.content || servicesResponse.data || [];
      const infrastructureRequests = infrastructuresResponse.data.content || infrastructuresResponse.data || [];

      const unansweredServicesCount = serviceRequests.filter((request: any) => !request.requestForServiceRespond).length;
      const unansweredInfrastructuresCount = infrastructureRequests.filter((request: any) => !request.requestForInfrastructureRespond)
        .length;

      // Sum up the counts of unanswered requests only
      this.newRequestsCount = unansweredServicesCount + unansweredInfrastructuresCount;
    } catch (error) {
      // Silently fail - don't show error to user, just set count to 0
      this.newRequestsCount = 0;
    }
  }

  public async fetchNewCollaborationsCount(): Promise<void> {
    try {
      if (!this.companyId) {
        this.newCollaborationsCount = 0;
        return;
      }

      // Fetch collaborations where my company is the advertiser (companyOffer)
      // collaborationSideFlags: [true, false] means we want collaborations where companyOffer is our company
      const response = await this.collaborationService().retrieveByCompany(
        this.companyId,
        [], // Empty array to get all statuses, we'll filter on client
        [true, false], // Get collaborations where our company is companyOffer (advertiser)
        [], // ratingSideFlags - not relevant for this count
        { page: 0, size: 1000 } // Get all to count
      );

      const collaborations = response.data.content || response.data || [];

      // Count only collaborations with PENDING status where my company is companyOffer
      const pendingCollaborationsCount = collaborations.filter((collaboration: any) => {
        return collaboration.status?.statusEn === 'Pending' && collaboration.companyOffer?.id === this.companyId;
      }).length;

      this.newCollaborationsCount = pendingCollaborationsCount;
    } catch (error) {
      // Silently fail - don't show error to user, just set count to 0
      this.newCollaborationsCount = 0;
    }
  }

  public getUserInitials(): string {
    const account = this.settingsAccount;
    if (account && account.firstName && account.lastName) {
      const initials = `${account.firstName.charAt(0)}${account.lastName.charAt(0)}`.toUpperCase();
      return initials;
    }
    return ''; // Ukoliko nisu dostupni podaci o imenu i prezimenu korisnika
  }

  public getCompanyLink(): string {
    const user = this.$store.getters.account;
    if (user) {
      this.portalUserService()
        .findByUserId(user.id)
        .then(res => {
          this.portalUser = res;
          if (this.portalUser.company) {
            this.companyLink = '/company/' + this.portalUser.company.id + '/view';
          }
          // // console.log(this.companyLink);
        });
    }

    return this.companyLink;
  }

  /**
   * Check if current route is an advertisement-related page
   * Used for breadcrumb/active menu highlighting
   */
  public get isAdvertisementRoute(): boolean {
    const currentPath = this.$route?.path || '';
    const currentName = this.$route?.name || '';

    // Check for advertisement-related routes
    const advertisementPaths = [
      '/advertisement',
      '/b2b/advertisement',
      '/research-infrastructure-pregled',
      '/ri-service-pregled',
      '/organization-preview',
    ];

    const advertisementNames = [
      'AdvertisementNew',
      'AdvertisementView',
      'AdvertisementEdit',
      'ResearchInfrastructurePregled',
      'RiServicePregled',
      'OrganizationPreview',
    ];

    // Check if path starts with any advertisement path
    const pathMatch = advertisementPaths.some(path => currentPath.startsWith(path));

    // Check if route name matches
    const nameMatch = advertisementNames.includes(currentName);

    return pathMatch || nameMatch;
  }
}
